<template>
    <div class="price-specification-vehicle">
        <div class="price-section">
            <div class="price-section-title">
                <span class="capitalize">
                    {{ t({ key: 'shared.transfer_product' }) }} -
                    {{ product.Vehicle.TransferCategory }}
                </span>
            </div>

            <div class="price-section-rows">
                <span>
                    {{
                        t({
                            key: product.GratuityIncluded
                                ? 'shared.tips_included_in_price'
                                : 'shared.tips_not_included_in_price',
                        })
                    }}
                </span>

                <span>
                    {{
                        t({
                            key: product.TollsIncluded
                                ? 'shared.toll_fees_included_in_price'
                                : 'shared.toll_fees_not_included_in_price',
                        })
                    }}
                </span>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, PropType } from 'vue';
    import { TransferProduct } from '@/api/Cart/cart.interfaces';

    export default defineComponent({
        name: 'PriceSpecificationVehicle',
        methods: { t },
        components: {},
        props: {
            product: {
                type: Object as PropType<TransferProduct>,
                required: true,
            },
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'PriceSpecificationTransfer';
</style>
